<template>
    <div class="search_nav">
        <el-form :inline="true" class="demo-form-inline">
            <el-form-item label="统计时间：">
                <el-date-picker
                    v-model="formInline.dateRange"
                    type="monthrange"
                    value-format="YYYY-MM"
                    range-separator="至"
                    start-placeholder="起始年月"
                    end-placeholder="截止年月"
                    style="width: 280px;"
                />
                <el-button style="margin-left: 5px;" @click="setDate('month')">本月</el-button>
                <el-button @click="setDate('lastMonth')">上月</el-button>
                <el-button @click="setDate('lastYear')">上一年</el-button>
            </el-form-item>
            <el-form-item>
                <div class="button_group">
                    <el-button type="primary" @click="getList">搜索</el-button>
                    <el-button type="primary" @click="getList">刷新</el-button>
                    <el-button type="primary" @click="exportData">导出</el-button>
                </div>
            </el-form-item>
        </el-form>
    </div>

    <el-table class="table_wrapper" :data="tableData" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
      <el-table-column label="平台" width="200" show-overflow-tooltip>
        <template #default="scope">
          <span>{{ scope.row.platFormName || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="月份" width="100">
        <template #default="scope">
          <span>{{ scope.row.monthStr || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="电费" width="120">
        <template #default="scope">
          <span>{{ scope.row.elecFee === null || scope.row.elecFee === '' || scope.row.elecFee === undefined ? '--' : (scope.row.elecFee || '0.00') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="充电服务费" width="120">
        <template #default="scope">
          <span>{{ scope.row.discSvcFee === null || scope.row.discSvcFee === '' || scope.row.discSvcFee === undefined ? '--' : (scope.row.discSvcFee || '0.00') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="订单总额" width="120">
        <template #default="scope">
          <span>{{ scope.row.orderAmt === null || scope.row.orderAmt === '' || scope.row.orderAmt === undefined ? '--' : (scope.row.orderAmt || '0.00') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="跨月订单开票金额" width="160">
        <template #default="scope">
          <span>{{ scope.row.delayedAmt === null || scope.row.delayedAmt === '' || scope.row.delayedAmt === undefined ? '--' : (scope.row.delayedAmt || '0.00') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="当月订单开票金额" width="160">
        <template #default="scope">
          <span>{{ scope.row.currentAmt === null || scope.row.currentAmt === '' || scope.row.currentAmt === undefined ? '--' : (scope.row.currentAmt || '0.00') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="开票总额" width="140">
        <template #default="scope">
          <span>{{ scope.row.amtGross === null || scope.row.amtGross === '' || scope.row.amtGross === undefined ? '--' : (scope.row.amtGross || '0.00') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="当月订单未开票金额">
        <template #default="scope">
          <span>{{ scope.row.unAmt === null || scope.row.unAmt === '' || scope.row.unAmt === undefined ? '--' : (scope.row.unAmt || '0.00') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="申报未开票总额">
        <template #default="scope">
          <span>{{ scope.row.unAmtGross === null || scope.row.unAmtGross === '' || scope.row.unAmtGross === undefined ? '--' : (scope.row.unAmtGross || '0.00') }}</span>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <Pagination
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
    />

</template>

<script>
import { ElMessage } from 'element-plus';
import moment from 'moment';

export default {
name:'InvoiceStatistics',
data() {
  return {
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      jumpPage: '',
      formInline: {
          dateRange: []
      }
  }
},
mounted(){
  this.getList();
},
methods:{
  getList(){
      let that = this;
      let param = {};
      param.page = that.currentPage;
      param.pageSize = that.pageSize;
      
      // 处理时间范围
      if(this.formInline.dateRange && this.formInline.dateRange.length === 2){
          param.startTime = this.formInline.dateRange[0];
          param.endTime = this.formInline.dateRange[1];
      }
      
      that.$axios.post(that.$store.state.platformApi + "invoiceRecord/statistics", JSON.stringify(param)).then(result => {
          if(result.code == 200){
              let dataObj = result.data;
              //遍历dataObj对象，将每一个属性作为一个数组合并到tableData数组中
              that.tableData = [];
              for(let key in dataObj) {
                dataObj[key].forEach((item, index) => {
                  that.tableData.push({
                    platFormName: index === 0 ? key : '',
                    ...item
                  });
                });
              }
              //如果platFormName==总合计，把它移到数组最后
              let totalIndex = that.tableData.findIndex(item => item.platFormName === '总合计');
              if(totalIndex !== -1) {
                let totalItem = that.tableData.splice(totalIndex, 1)[0];  // ✅ 先获取被删除的元素
                totalItem.monthStr = '';
                that.tableData.push(totalItem);  // ✅ 再添加到末尾
              }
              // 重新计算total
              that.total = that.tableData.length;
          }
      });
  },
  handleSizeChange(val) {
    this.pageSize = val;
    this.getList();
  },
  handleCurrentChange(val) {
    this.currentPage = val;
    this.getList();
  },
  setDate(type) {
      let startTime, endTime;
      switch(type) {
           case 'month':
                // 本月
                startTime = moment().startOf('month').format('YYYY-MM');
                endTime = moment().endOf('month').format('YYYY-MM');
                break;
            case 'lastMonth':
                // 上一个月
                startTime = moment().subtract(1, 'month').startOf('month').format('YYYY-MM');
                endTime = moment().subtract(1, 'month').endOf('month').format('YYYY-MM');
                break;
            case 'lastYear':
                // 去年
                startTime = moment().subtract(1, 'year').startOf('year').format('YYYY-MM');
                endTime = moment().subtract(1, 'year').endOf('year').format('YYYY-MM');
                break;
        }
        this.formInline.dateRange = [
            startTime,
            endTime
        ];
  },
  exportData() {
      let that = this;
      let param = {};
      
      // 处理时间范围
      if(this.formInline.dateRange && this.formInline.dateRange.length === 2){
          param.startTime = this.formInline.dateRange[0];
          param.endTime = this.formInline.dateRange[1];
      }
      
      that.$axios.post(that.$store.state.platformApi + "invoiceRecord/exportStatistics", JSON.stringify(param), {responseType: 'blob'}).then(result => {
          // 处理下载
      });
  }
}
}
</script>

<style lang="scss" scoped>
.search_nav{
  padding: 15px;
  background: #fff;
  margin-bottom: 15px;
}
.button_group{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  button{
      margin-left: 10px;
  }
}
</style>